export { SearchModalProvider, useSearchModal } from './context/search-modal-context'
export { default as SearchDesktop } from './search-desktop'
